<template>
  <v-container>
    <TaxWarrantsCriteria :baseCrudKey="baseCrudKey"
    @loadCRUDList="handleLoadWarrantList"/>
    <div class="mt-10">
    <CRUDList class="mt-10" ref="crudList"
    toolbarTitle="Tax Roll" :canAdd="true" :canEdit="true" :canSave="true" :canMultipleDelete="true"
      :showSelect="true" :enableFixedHeaders="true" :displayTopPagination="false" :headers="headers"
      :baseCrudKey="baseCrudKey"
      tableWrapperDynamicClassname='elevation-3 mt-n5 ma-3 pt-0 pa-1 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='200'
      :defaultSortBy="defaultSortBy"
      :selectedItems="selectedItems"
      :createNewItem="newItemDialog"
      @upsertItem="upsertTransaction"
      @emitSelectedItem="taxWarrantSelectedItem"
      @onSingleClicked="handleSingleOrArrowClick"
      @loadCRUDList = "handleLoadWarrantList"
      @handleMultipleDelete="handleMultipleDelete"
      :loadingData="gridLoading.flag"
      :dialogDynamicWidth=dialogWidth
      :loadingText="gridLoading.text"
      @activateItem="activateTransaction"
      :uploadFileParams="uploadFileParams" >
      <template v-slot:[`editedItem`]="{ }">
        <WarrantDialog
         :baseCrudKey="baseCrudKey" />
      </template>
      <template v-slot:[`additionalActions`]="{}">
      <UploadFile
      v-if="!isNewItem"
      id="warTransUploadFile"
          class="wartrans uploadFile"
          :bucketName="attachmentConstants.bucketName"
          :program="attachmentConstants.program"
          :parentObjectType="attachmentConstants.parentObjectType"
          :parentObjectId="getActiveTransID || ''"
          :itemIsSaved="!isNewItem"
        ><template v-slot:activator="{ activatorProps }">
        <v-btn
          color="primary"
          text
          @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
          @click="imagesLeftClick(activatorProps.leftClick)"
        >
        {{activatorProps.caption}}
        </v-btn>
        </template>
       </UploadFile>
        <v-btn
      class="input-text-size"
        v-if="!isNewItem"
        color="error"
        text
        @click="handleDeleteSingleRecord"
      >
        Delete
      </v-btn>

    </template>
    </CRUDList>
    <template>
      <div>
        <v-row class='my-6'>
          <v-col cols='8' class='pt-2'>
            <WarrantDetailsList />
          </v-col>
          <v-col cols='4' class=" justify-center ">
            <v-container>
              <div class="btns px-14">
                <v-btn color='primary' dense small class="my-4" @click="handleReport('ptwWarrant')">
                  Print Personal Tax Warrant
                </v-btn> <v-btn color='primary' dense small @click="handleReport('ptwLetter')">
                  Print Tax Warrant Letter
                </v-btn>
                <v-btn color='primary' dense small class="my-4" @click="handleReport('ptwStatement')">
                  Print Statement
                </v-btn>
              </div>
              <div class="px-14 mt-2">
                <div class="d-flex align-center">
                  <div class="flex-grow-1">
                    <ClarionDateControl
                      class='input-text-size'
                      :isIsoDate='true'
                      :isRequired='false'
                      :isToggle='false'
                      :penalty-change-day="Number(taxSettingItem.penaltyDate) || null"
                      v-model='penaltyDate'
                      label='Penalty Date'
                    />
                  </div>
                  <div class="pl-3">
                    <v-btn color='primary' dense small @click="savePenaltyDate">
                      Save
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-container>
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
  </v-container>

</template>

<script>
import { mapActions } from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import WarrantDetailsList from './TaxWarrantsDetailsList.vue';
import { taxWarrantsHeader } from './TaxWarrantHeaders.utils';
import WarrantDialog from './WarrantDialog.vue';
import TaxWarrantsCriteria from './TaxWarrantsCriteria.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import '../../../assets/style.css';
import { clients } from '../../../util/clients';
import UploadFile from '../../common/UploadFile.vue';
import { TaxWarrantsMixin, TaxWarrantsDialogMixin } from './utils/taxWarrants.mixin';
import {
  createNewWarrantItem,
} from './utils/taxWarrants.util';

const { backendRest } = clients.direct;
export default {
  name: 'TaxWarrantsList',
  mixins: [TaxWarrantsMixin, TaxWarrantsDialogMixin],
  data() {
    return {
      headers: taxWarrantsHeader,
    };
  },
  components: {
    WarrantDetailsList,
    CRUDList,
    WarrantDialog,
    TaxWarrantsCriteria,
    UploadFile,
    ClarionDateControl,
  },

  watch: {
    latestTaxYear(newVal, oldVal) {
      if (newVal && !oldVal) this.criteriaState.taxYear = this.latestTaxYear;
      if (newVal !== 0) {
        this.isItFirstCallOrNot = true;
        this.handleLoadWarrantList();
      }
    },
  },

  methods: {
    ...mapActions('tax/taxWarrants', ['upsertWarrants', 'loadLastWarrantNo', 'loadLastSystemID', 'deleteTaxWarrants', 'bulkDeleteTaxWarrants']),

    // Override mixin methods to use the same CRUD key for both operations
    getEditedItemCrudKey() {
      return this.baseCrudKey;
    },

    getUpsertCrudKey() {
      return this.baseCrudKey;
    },

    // Override mixin method: also sync the Penalty Date field from the first
    // checked row, same as the single-click/arrow-key path below already does.
    taxWarrantSelectedItem(items) {
      this.selectedItems = items;
      const selectedRows = (items || []).filter((el) => typeof el === 'object');
      if (selectedRows.length && selectedRows[0].penaltyDate) {
        this.penaltyDate = selectedRows[0].penaltyDate;
      }
    },

    // Override mixin method to handle warrant details list
    handleSingleOrArrowClick(fromCrud) {
      const selectedRowData = { ...fromCrud };
      const taxInqCrudKey = 'taxdetailsWarrantList';
      const itemData = (selectedRowData || {}).taxWarrantDetails;
      this.setItems([taxInqCrudKey, itemData]);
      // Sync penalty date from selected warrant
      if (selectedRowData.penaltyDate) {
        this.penaltyDate = selectedRowData.penaltyDate;
      }
    },

    // Hook for post-upsert actions specific to this component
    async afterUpsert() {
      // Custom post-upsert actions for TaxWarrantsList
      this.errorMessage = null; // Ensure error message is cleared
      this.setDefaultSelectedItems();
      this.handleLoadWarrantList();
    },

    // Custom new item creation method
    newItemDialog() {
      return createNewWarrantItem({
        taxYear: this.criteriaState.taxYear,
        taxId: this.criteriaState.taxId,
        // Prefix is the county's current tax year, not the searched tax year.
        warrantTaxYear: this.currentWarrantTaxYear,
        nextWarrantNumber: this.nextWarrantNumber,
        nextWarrantSystemID: this.nextWarrantSystemID,
        taxSettingItem: this.taxSettingItem,
      });
    },

    // Custom post process method
    postProcessData(items) {
      return this.postProcessWarrantData(items);
    },

    // Report handling method
    async handleReport(status) {
      const items = this.selectedItems.filter((el) => typeof el === 'object');
      const item = this.item(this.baseCrudKey);
      const idArr = items.map((el) => el._id);

      if (item._id && !idArr.includes(item._id)) {
        idArr.push(item._id);
      }

      if (idArr.length < 1) {
        this.custumColrFlashMsg({ msg: 'Please select a record' });
        return;
      }

      const ids = idArr.join();
      const { jwt } = await this.reAuth();
      const criteria = {
        ids,
        token: jwt,
      };

      let slug;
      if (status === 'ptwWarrant') {
        slug = 'tax/personal-taxwarrant-report';
      } else if (status === 'ptwLetter') {
        slug = 'tax/personal-taxwarrant-letter-report';
      } else if (status === 'ptwStatement') {
        slug = 'tax/personal-taxwarrant-statement';
      }

      const toUrl = `${backendRest.defaults.baseURL}/${slug}?${this.urlEncodeObject(criteria)}`;
      window.open(toUrl);
    },

    // Handle multiple delete
    async handleMultipleDelete() {
      const items = this.selectedItems.filter((el) => typeof el === 'object');
      const item = this.item(this.baseCrudKey);
      const idArr = items.map((el) => el._id);

      if (item._id && !idArr.includes(item._id)) {
        idArr.push(item._id);
      }

      if (idArr.length < 1) {
        this.custumColrFlashMsg({ msg: 'Please select a record to delete' });
        return;
      }

      // const confirmed = await this.$confirm(
      //   `Are you sure you want to delete ${idArr.length} record(s)?`,
      //   { title: 'Confirm Delete' },
      // );

      // if (!confirmed) return;

      try {
        await this.bulkDeleteTaxWarrants({ ids: idArr, baseCrudKey: this.baseCrudKey });
        this.setDefaultSelectedItems();
        this.handleLoadWarrantList();
      } catch (error) {
        this.custumColrFlashMsg({ msg: 'Error deleting records', color: 'error' });
      }
    },

    async savePenaltyDate() {
      const currentItem = this.item(this.baseCrudKey);
      const selected = this.selectedItems.filter((el) => typeof el === 'object');
      const targets = selected.length ? selected : [currentItem];

      if (!targets.length || targets.some((el) => !el || !el._id)) {
        this.custumColrFlashMsg({ msg: 'Please select a warrant record first' });
        return;
      }
      try {
        await Promise.all(targets.map((target) => this.upsertWarrants({
          item: {
            _id: target._id,
            taxYear: target.taxYear,
            taxId: target.taxId,
            penaltyDate: this.penaltyDate,
          },
          baseCrudKey: this.baseCrudKey,
          // one flash for the whole bulk save, not one per record
          silent: true,
        })));
        // The mutation response is a thin payload (only the fields we sent), so
        // merging it directly over the grid rows blanks out columns like Parcel ID
        // and Name. Reload from the server instead of relying on the merge.
        // Also filter the grid to that same penalty date so the user can see
        // exactly which records were just updated.
        this.criteriaState = { ...this.criteriaState, penaltyDate: this.penaltyDate };
        await this.handleLoadWarrantList();

        // The active item (driving WarrantDialog and the taxWarrantDetails sub-grid) is
        // separate Vuex state from the list - reloading the list above doesn't refresh it,
        // so without this the Penalty/Total Due columns would keep showing pre-recalculation
        // values until the user manually reselects the row.
        if (currentItem && currentItem._id) {
          const refreshed = this.items(this.baseCrudKey)
            .find((el) => el._id === currentItem._id);
          if (refreshed) {
            this.setItem([this.baseCrudKey, refreshed]);
            this.setItems(['taxdetailsWarrantList', refreshed.taxWarrantDetails || []]);
          }
        }

        this.flashSuccess('Penalty date saved successfully');
      } catch (error) {
        this.custumColrFlashMsg({ msg: 'Error saving penalty date', color: 'error' });
      }
    },

    // Handle single record delete from dialog
    async handleDeleteSingleRecord() {
      const item = this.item(this.baseCrudKey);

      if (!item || !item._id) {
        this.custumColrFlashMsg({ msg: 'No record selected to delete' });
        return;
      }

      try {
        await this.deleteTaxWarrants({ item, baseCrudKey: this.baseCrudKey });
        this.setDefaultSelectedItems();
        this.handleLoadWarrantList();
      } catch (error) {
        this.custumColrFlashMsg({ msg: 'Error deleting record', color: 'error' });
      }
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 0.85rem;
}
</style>
